<h1 mat-dialog-title class="w-100"><i class="fa-solid fa-address-book"></i> Wprowadź adresy kontaktowe firmy</h1>
<form [formGroup]="formContact">
	<mat-dialog-content class="mat-typography w-100">
		<mat-form-field class="w-100">
			<mat-select
				placeholder="Dział"
				required
				formControlName="kind"
				[compareWith]="organizationContactComparison"
			>
				@for (item of departmentKinds; track item.id) {
					<mat-option [value]="item"> {{ item.name }}</mat-option>
				}
			</mat-select>
			<mat-error class="error-kind">Dział jest wymagany</mat-error>
		</mat-form-field>
		<ng-container formArrayName="departmentContacts">
			@for (contact of contacts.controls; track contact.value.id; let i = $index) {
				<div [formGroupName]="i" class="d-flex flex-row justify-content-between align-items-center">
					<mat-form-field class="w-100 mx-2">
						<input matInput type="email" placeholder="Email" formControlName="email" />
						<mat-error>Adres email jest wymagany</mat-error>
					</mat-form-field>
					<mat-form-field class="w-100">
						<input matInput type="tel" placeholder="telefon" formControlName="phone" />
						<mat-error>Numer telefonu jest wymagany</mat-error>
					</mat-form-field>
					@if (i > 0) {
						<i class="fa-solid fa-trash-can p-3" (click)="removeSubContact(i)"></i>
					}
				</div>
			}
		</ng-container>
		<button mat-raised-button color="accent" class="w-100 my-2" (click)="addSubContacts()">
			Dodaj kolejne adresy kontaktowe
		</button>
		@if (!contacts.length) {
			<i class="errors">* Przed dodaniem uzupełnij kontakt</i>
		}
		<mat-form-field class="w-100">
			<mat-select
				placeholder="Osoba odpowiedzialna"
				formControlName="userResponsibility"
				[compareWith]="organizationContactComparison"
			>
				@for (item of departmentUsers; track item.id) {
					<mat-option [value]="item">{{ item.email }}</mat-option>
				}
			</mat-select>
			<mat-error class="error-user-responsibility">Osoba odpowiedzialna jest wymagana</mat-error>
		</mat-form-field>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-raised-button color="warn" (click)="cancelForm()">Anuluj</button>
		<button class="submit-form-button" mat-raised-button color="primary" (click)="submitForm()">
			{{ submitButtonText }}
		</button>
	</mat-dialog-actions>
</form>
